import { Link } from "react-router-dom";
import { CalendarClock, ArrowRight } from "lucide-react";

const dayLabel = (d) => (d < 0 ? `${-d} gün gecikti` : d === 0 ? "Bugün" : `${d} gün kaldı`);

export const UpcomingDeliveries = ({ items }) => {
  if (!items?.length) return null;
  return (
    <section className="mb-8 rounded-lg border border-[#D97706]/50 bg-[#FBF1DF] p-5" data-testid="upcoming-deliveries-card">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <CalendarClock className="w-5 h-5 text-[#B45309]" />
          <h2 className="font-display text-xl font-bold uppercase tracking-tight">Teslimi Yaklaşan Siparişler</h2>
        </div>
        <Link to="/siparis" data-testid="upcoming-deliveries-link"
          className="text-sm font-medium text-[#B45309] hover:text-[#78350F] flex items-center gap-1">
          Siparişlere git <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
      <div className="space-y-2">
        {items.map((o) => {
          const late = o.days_left < 0;
          return (
            <div key={o.id} data-testid={`upcoming-order-${o.id}`}
              className={`flex items-center justify-between rounded-md border px-4 py-2.5 bg-[#FFFBF4] ${late ? "border-[#EF4444]/50" : "border-[#DCCFB8]"}`}>
              <div className="min-w-0">
                <p className="text-sm font-semibold truncate">{o.customer_name}</p>
                <p className="text-[11px] font-mono text-[#8C7B68] uppercase">Teslim: {new Date(o.delivery_date).toLocaleDateString("tr-TR")} · Kalan {o.remaining} çift</p>
              </div>
              <span data-testid={`upcoming-days-${o.id}`}
                className={`text-xs font-mono uppercase tracking-wider px-2 py-1 rounded border shrink-0 ${late ? "bg-[#EF4444]/15 text-[#B91C1C] border-[#EF4444]/40" : o.days_left <= 2 ? "bg-[#F59E0B]/20 text-[#B45309] border-[#F59E0B]/40" : "bg-[#EFE6D6] text-[#6B5B4A] border-[#DCCFB8]"}`}>
                {dayLabel(o.days_left)}
              </span>
            </div>
          );
        })}
      </div>
    </section>
  );
};
